var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfigure(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.5L4 16.5C3.72386 16.5 3.5 16.2761 3.5 16L3.5 8C3.5 7.72386 3.72386 7.5 4 7.5L7 7.5L7 6L4 6C2.89543 6 2 6.89543 2 8L2 16C2 17.1046 2.89543 18 4 18L12 18C13.1046 18 14 17.1046 14 16L14 14L12.5 14L12.5 16C12.5 16.2761 12.2761 16.5 12 16.5Z",
    fill: "#5E5E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.492 3.35013L9.37697 8.47331L8.53461 11.4676L11.5327 10.6272L16.6477 5.50308C16.7093 5.44149 16.7444 5.35749 16.7444 5.27041C16.7444 5.18341 16.7099 5.09997 16.6483 5.0384L14.957 3.35019C14.8954 3.28862 14.8117 3.25398 14.7245 3.25398C14.6374 3.25398 14.5536 3.28866 14.492 3.35013ZM13.6043 2.46331C13.9014 2.16665 14.3043 2 14.7245 2C15.1446 2 15.5475 2.16663 15.8446 2.46325L17.5359 4.15146C17.8329 4.4482 18 4.85081 18 5.27041C18 5.69 17.8331 6.09242 17.5361 6.38916L12.3053 11.6292C12.2291 11.7055 12.1344 11.7609 12.0305 11.79L7.79745 12.9767C7.57892 13.0379 7.3443 12.9766 7.18383 12.8163C7.02336 12.656 6.96202 12.4216 7.02342 12.2034L8.2125 7.97666C8.24155 7.87342 8.29662 7.77935 8.37246 7.70343L13.6043 2.46331Z",
    fill: "#5E5E66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.6b9dc3d9.svg";
export { ForwardRef as ReactComponent };